import { render, staticRenderFns } from "./AggregatedReports-tankundrast.vue?vue&type=template&id=30a46072&"
import script from "./AggregatedReports-tankundrast.vue?vue&type=script&lang=js&"
export * from "./AggregatedReports-tankundrast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports